import { partition, sortBy } from 'lodash-es'

import type { EquipmentTypeOption } from '@/features/settings/contracted-rates/types'
import { useFavoriteEquipmentTypes } from '@/features/settings/user-preferences/hooks'
import type { EquipmentTypeEnum } from '@/types'

import { useQuoteSettings } from './settings'

/** Truckload equipment with the user's favorites first, in their preferred order. */
export const useTruckloadEquipmentOptions = () => {
  const quoteSettingsQuery = useQuoteSettings('truckload')
  const favoriteTypes = useFavoriteEquipmentTypes()
  const equipmentOptions = quoteSettingsQuery.data?.equipmentOptions ?? []
  const [favoriteOptions, otherOptions] = partition(equipmentOptions, o =>
    favoriteTypes.includes(o.key),
  )
  const favorites = sortBy(favoriteOptions, o => favoriteTypes.indexOf(o.key))

  return {
    isLoaded: !!quoteSettingsQuery.data,
    favorites,
    others: otherOptions,
    options: favorites.concat(otherOptions),
  }
}

export const toEquipmentTypeOption = (
  o: EquipmentTypeEnum,
): EquipmentTypeOption => ({
  label: o.name,
  value: o.key,
})
